import styled from 'styled-components';
import React, {useContext} from 'react';
import DataContext from '../DataContext/DataContext';


const EmptyStyle =  styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  padding: 1rem 1.3rem;
  display: flex;
  align-items: center;
  z-index: 3001;
`;

const EmptyStyleMultiple =  styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  padding: 0.7rem 1.3rem;
  display: flex;
  align-items: center;
  z-index: 3001;
`;



export default function EmptyStyles() {

    const { config} = useContext(DataContext);

 const languageCount = config.ifoodPPSILanguageCodes;
  return (
    <>
      {languageCount && languageCount.length > 1? <EmptyStyleMultiple/> : <EmptyStyle/>}
    </>
  )
}
